import { createRouter, createWebHistory, RouteLocationNormalized, RouteRecordRaw } from 'vue-router'
import ArticleTypeView from '../views/ArticleType.vue'
import UploadFiles from '../views/UploadFiles.vue'
import ReviewEditorial from '../views/ReviewEditorial.vue'
import ArticleInfo from '../views/ArticleInfo.vue'
import AuthorInfo from '../views/AuthorInfo.vue'
import FinalReview from '../views/FinalReview.vue'
import SubmissionDone from '../views/SubmissionDone.vue'
import CookiesRsc from '../views/CookiesRsc.vue'
import NotFound from '../views/error/NotFound.vue'
import ServerError from '../views/error/ServerError.vue'
import MaintenancePage from '../views/MaintenancePage.vue'
import store from '../store'
import { ARTICLE_TYPES } from '@/constants/app'

const routes: RouteRecordRaw[] = [
  { path: '/', redirect: '/submission/article-type' },
  { path: '/submission', redirect: '/submission/article-type' },
  { path: '/submission/article-type', component: ArticleTypeView, name: 'article-type', meta: { title: 'Article type' } },
  { path: '/submission/upload-files', component: UploadFiles, meta: { step: 1, title: 'Manuscript files', requiresArticleType: true }, name: 'upload-files' },
  { path: '/submission/article-info', component: ArticleInfo, meta: { step: 2, title: 'Title & abstract', requiresArticleType: true }, name: 'article-info' },
  { path: '/submission/author-info', component: AuthorInfo, meta: { step: 3, title: 'Authors', requiresArticleType: true }, name: 'author-info' },
  { path: '/submission/review-editorial', component: ReviewEditorial, meta: { step: 4, title: 'Reviewers', requiresArticleType: true }, name: 'review-editorial' },
  { path: '/submission/final-review', component: FinalReview, meta: { step: 5, title: 'Final check & review', requiresArticleType: true }, name: 'final-review' },
  { path: '/submission/done', component: SubmissionDone, name: 'done', meta: { title: 'Submission complete', requiresArticleType: true } },
  { path: '/submission/cookies', component: CookiesRsc, name: 'cookies', meta: { title: 'Cookies list' } },
  { path: '/:pathMatch(.*)*', name: 'not-found', component: NotFound, meta: { title: 'Page not found' } },
  { path: '/error', name: 'server-error', component: ServerError, meta: { title: 'Server error' } },
  { path: '/submission/maintenance', name: 'maintenance', component: MaintenancePage, meta: { title: 'Maintenance' } },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    // always scroll to top
    return { top: 0 }
  },
})

router.beforeEach((to: RouteLocationNormalized) => {
  store.commit('setFeatureFlagsEnabled', to.query)
  document.title = (to.meta.title as string) || 'RSC Submission Portal'

  if (!to.meta.requiresArticleType) return true

  const articleType = store.state.activeSubmission.articleType
  const isValidType = articleType && ARTICLE_TYPES.includes(articleType)

  if (!isValidType) {
    return { name: 'article-type' }
  }
})

declare module 'vue-router' {
  interface RouteMeta {
    step?: number
    title?: string
    requiresArticleType?: boolean
  }
}

export default router
